import * as React from 'react';

import { Layout } from '../../../Layout';
import * as style from './HeaderContent.css';

interface IHeaderContentProps {
  sticky?: boolean;
}

const HeaderContentComponent = (props: React.PropsWithChildren<IHeaderContentProps>) => {
  const { children, sticky } = props;

  if (sticky) {
    return (
      <div className={style['container--sticky']}>
        <Layout>
          <div className={style['content']}>{children}</div>
        </Layout>
      </div>
    );
  }

  return <div className={style['content']}>{children}</div>;
};

export const HeaderContent = React.memo(HeaderContentComponent);
